import * as dashboardActions from '../actions/dashboardActions/constants'

const initialState = {
    dashboard: null,
    topHolders: null,
    presale: null,
    isLoadingDashboard: true,
    isLoadingTopHolders: true,
    isLoadingPresale: true
};

const walletReducer = (state = initialState, action) => {
    switch (action.type) {
        case dashboardActions.GET_TOP_HOLDERS_REQUEST:
            return {
                ...state,
                isLoadingTopHolders: true
            };
        case dashboardActions.GET_TOP_HOLDERS_SUCCESS:
            return {
                ...state,
                isLoadingTopHolders: false,
                topHolders: action.payload
            };
        case dashboardActions.GET_TOP_HOLDERS_FAILURE:
            return {
                ...state,
                isLoadingTopHolders: false,
                topHolders: null
            };
        case dashboardActions.GET_DASHBOARD_REQUEST:
            return {
                ...state,
                isLoadingDashboard: true
            };
        case dashboardActions.GET_DASHBOARD_SUCCESS:
            return {
                ...state,
                isLoadingDashboard: false,
                dashboard: action.payload
            };
        case dashboardActions.GET_DASHBOARD_FAILURE:
            return {
                ...state,
                isLoadingDashboard: false,
                dashboard: null
            };
        case dashboardActions.GET_PRESALE_REQUEST:
            return {
                ...state,
                isLoadingPresale: true
            };
        case dashboardActions.GET_PRESALE_SUCCESS:
            return {
                ...state,
                isLoadingPresale: false,
                presale: action.payload
            };
        case dashboardActions.GET_PRESALE_FAILURE:
            return {
                ...state,
                isLoadingPresale: false,
                presale: null
            };
        case dashboardActions.SET_DEFAULT_DASHBOARD:
            return {
                ...state,
                dashboard: null,
                topHolders: null
            };
        case dashboardActions.SET_DEFAULT_TOP_HOLDERS:
            return {
                ...state,
                topHolders: null
            };
        default:
            return state
    }
}

export default walletReducer